<template>
  <v-select
    :placeholder="placeholder"
    v-model="selectedOption"
    :options="options"
    label="text"
    @search="onSearchOptions"
    @input="onSelectOption"
    :loading="searchOpts.isLoading"
  >
    <template #no-options>
      {{ noOptsMessage() }}
    </template>
  </v-select>
</template>

<script>
import vSelect from 'vue-select';

export default {

  name: "SearchOpts",

  props: {

    value: { // Esto es necesario para v-model
      type: Object,
      default: null
    },
    
    data: { // Esto es necesario para v-model
      type: Object,
      default: null,
      required: false
    },
    
    searchService: {
      type: Function, // El servicio se pasa como función desde el padre
      required: true
    },

    omit: {
      type: Array,
      default: () => []
    },

    placeholder: {
      type: String,
      default: "Buscar..."
    },

    minChars: {
      type: Number,
      default: 5
    },

    establecimiento: {
      type: String,
      default: ''
    }
  },

  components:{
    vSelect
  },


  created() {
    this.selectedOption = this.value;
  },

  data() {
    return {

      options: [],

      searchOpts:{
        query:'',
        isLoading:false,
        searchFailed:false,
        selected:null       
      },

      selectedOption: null,
    }
  },


  methods: {

    async onSearchOptions(query) {

      this.searchOpts.query = query;

      if(query.length < this.minChars) {
        this.options = []; 
        return;
      }

      this.searchOpts.isLoading = true;
      this.options = [];
      this.options = await this.onFilterOptions(query);
      this.searchOpts.isLoading = false;
    },

    noOptsMessage() {

      const nChars = this.searchOpts.query.length;

      if (nChars <= this.minChars) 
        return `Escribe ${this.minChars - nChars} caracteres ${nChars > 0 ? 'mas' : ''} para buscar...`;

      if (this.searchOpts.isLoading) 
        return 'Buscando opciones...';
      
      if (this.searchOpts.searchFailed) 
        return 'Error al buscar opciones. Intente de nuevo.';
      
      if (this.options.length === 0 && !this.searchOpts.isLoading) 
        return 'No se encontraron opciones que coincidan con tu búsqueda';
      
      return 'Escribe para buscar opciones...';
    },


    async onFilterOptions(query){
      const options = await this.searchService(query, this.establecimiento);
      if(!options) return [];

      // el service debe devolver un array de objetos con el campo 'value' y 'text'
      // ejemplo:
      // const data = response2.map(persona => {
      //   return {
      //     ...persona,
      //     value: persona.id,
      //     text: `${persona.identificacion} ${persona.primerApellido} ${persona.primerNombre}`
      //   }
      // })

      const omitIds = this.omit.map(opt => opt.id);

      if(omitIds.length === 0) return options;

      return options.filter( opt => !omitIds.includes(opt.value) );
    },


    onSelectOption(value) {
      this.$emit('input', value);
    },
  },

  watch: {
    
    value(newVal) {
      // console.log("value", newVal)
      this.selectedOption = newVal;
    },
    data: {
      deep: true,
      immediate : true,
      handler(newVal) {
        this.selectedOption = newVal;
        // console.log('omit', newVal);
      }
    },

    omit: {
      deep: true,
      handler(newVal) {
        // console.log('omit', newVal);
      }
    }
  }

}
</script>
